import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const linkedIn = defineConnector({
  identifier: "linkedIn",
  name: "LinkedIn",
  tagLine: "Professional network APIs",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.linkedin\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create an OAuth 2.0 access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://learn.microsoft.com/en-us/linkedin/shared/authentication/authentication](https://learn.microsoft.com/en-us/linkedin/shared/authentication/authentication) and [https://learn.microsoft.com/en-us/linkedin/shared/authentication/authorization-code-flow](https://learn.microsoft.com/en-us/linkedin/shared/authentication/authorization-code-flow) to create an OAuth 2.0 access token for the LinkedIn API.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "OAuth 2.0 access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.linkedin.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api.linkedin.com/v2/me")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
